const initialState = {
  contractsList: [],
  contractDetails: {},
  selectedContract: 0,
  contractToConfirm: null,
  orderlineEndDateEdit: { id: 0, date: null },
  orderlineInvoiceDateEdit: { id: 0, date: null },
  invoiceTwidEdit: { id: 0, twid: null },
  newInvoices: [],
  pastInvoices: [],
  invoiceDetails: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "invoicing/setInvoiceTwidEdit":
      return { ...state, invoiceTwidEdit: action.payload };
    case "invoicing/setOrderlineEndDateEdit":
      return { ...state, orderlineEndDateEdit: action.payload };
    case "invoicing/setOrderlineInvoiceDateEdit":
      return { ...state, orderlineInvoiceDateEdit: action.payload };
    case "invoicing/storeContractsList":
      return { ...state, contractsList: action.payload };
    case "invoicing/setSelectedContract":
      return { ...state, selectedContract: action.payload };
    case "invoicing/storeContractDetails":
      return { ...state, contractDetails: action.payload };
    case "invoicing/storeUnconifrmed":
      return { ...state, contractToConfirm: action.payload };
    case "invoicing/storePastInvoices":
      return { ...state, pastInvoices: action.payload };
    case "invoicing/storeNewInvoices":
      return { ...state, newInvoices: action.payload };
    case "invoicing/nullContractDetails":
      return { ...state, contractDetails: {} };
    case "invoicing/nullContractToConfirm":
      return { ...state, contractToConfirm: null };
    case "invoicing/storeInvoiceDetails":
      return { ...state, invoiceDetails: action.payload };
    default:
      return state;
  }
}
